// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ProtectedRoute_spinnerContainer__e7YrK"};